module.exports = __webpack_public_path__ + "img/bookcase-top.be5ddb5a.svg";